<template>
  <v-dialog v-model="internalShow" :width="width" persistent :scrollable="scrollable">
    <v-card>
      <div class="modal-header" style="background-color: #e2e8f0">
        <div class="d-flex align-center justify-space-between px-6 py-4">
          <div class="d-flex align-center flex-grow-1">
            <v-icon v-if="icon" class="mr-3" :color="iconColor">{{ icon }}</v-icon>
            <span class="text-h6 font-weight-bold" style="color: #334155">{{ title }}</span>
          </div>
          <v-btn icon small @click="closeModal" class="ml-2">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
      </div>

      <v-divider></v-divider>

      <v-card-text class="mt-6 mb-4">
        <slot></slot>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions class="pa-4">
        <template v-if="$scopedSlots.actions || $slots.actions">
          <slot name="actions" :close="closeModal" :submit="handleSubmit"></slot>
        </template>
        <template v-else>
          <v-spacer></v-spacer>
          <v-btn
            :disabled="cancelDisabled || loading"
            color="textPrimary"
            text
            @click="closeModal"
            class="font-weight-medium"
          >
            {{ cancelText }}
          </v-btn>
          <v-btn
            :loading="loading"
            :disabled="submitDisabled || loading"
            :dark="!submitDisabled && !loading"
            color="success"
            @click="handleSubmit"
            class="font-weight-medium"
          >
            <v-icon v-if="submitIcon" left>{{ submitIcon }}</v-icon>
            {{ submitText }}
          </v-btn>
        </template>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "CustomModal",
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      default: null,
    },
    iconColor: {
      type: String,
      default: "#334155",
    },
    width: {
      type: [String, Number],
      default: "600",
    },
    submitText: {
      type: String,
      default: "Salvar",
    },
    submitIcon: {
      type: String,
      default: null,
    },
    cancelText: {
      type: String,
      default: "Cancelar",
    },
    loading: {
      type: Boolean,
      default: false,
    },
    submitDisabled: {
      type: Boolean,
      default: false,
    },
    cancelDisabled: {
      type: Boolean,
      default: false,
    },
    scrollable: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    internalShow: {
      get() {
        return this.show;
      },
      set(value) {
        if (!value) {
          this.$emit("close");
        }
      },
    },
  },
  methods: {
    closeModal() {
      this.$emit("close");
    },
    handleSubmit() {
      this.$emit("submit");
    },
  },
};
</script>

<style scoped>
.modal-header {
  border-radius: 4px 4px 0 0;
  flex: 0 0 auto;
}

::v-deep .v-dialog:not(.v-dialog--scrollable) > .v-card,
::v-deep .v-dialog:not(.v-dialog--scrollable) > .v-card > .v-card__text {
  overflow: visible;
}

::v-deep .v-card__text {
  color: #334155;
  overflow-y: auto;
}

::v-deep .v-card__text::-webkit-scrollbar,
::v-deep .v-card__text *::-webkit-scrollbar {
  width: 6px;
}
::v-deep .v-card__text::-webkit-scrollbar-track,
::v-deep .v-card__text *::-webkit-scrollbar-track {
  background: transparent;
}
::v-deep .v-card__text::-webkit-scrollbar-thumb,
::v-deep .v-card__text *::-webkit-scrollbar-thumb {
  background: rgba(51, 65, 85, 0.2);
  border-radius: 3px;
  transition: background 0.2s ease;
}
::v-deep .v-card__text::-webkit-scrollbar-thumb:hover,
::v-deep .v-card__text *::-webkit-scrollbar-thumb:hover {
  background: rgba(51, 65, 85, 0.35);
}
::v-deep .v-card__text::-webkit-scrollbar-corner,
::v-deep .v-card__text *::-webkit-scrollbar-corner {
  background: transparent;
}
</style>
